import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { NewBadge, StarButton, CompareButton } from "@/components/CareerActions";

export const CareerCard = ({ c, color, i }) => (
  <Link to={`/careers/${c.id}`} data-testid={`explore-career-${c.id}`}
    className="group rounded-2xl bg-white border border-[#1C242B]/10 p-5 flex flex-col hover:-translate-y-0.5 hover:shadow-[0_10px_30px_-12px_rgba(28,36,43,0.25)] transition-[transform,box-shadow] duration-300 animate-in fade-in"
    style={{ animationDelay: `${Math.min(i, 12) * 30}ms` }}>
    <div className="flex items-center gap-2">
      <span className="inline-flex items-center gap-1.5 text-xs text-slate-500 min-w-0">
        <span className="w-2 h-2 rounded-full shrink-0" style={{ background: color }} /><span className="truncate">{c.cluster_label}</span>
      </span>
      {c.is_new && <NewBadge testId={`new-badge-${c.id}`} />}
      <span className="ms-auto flex -me-1.5 -mt-1">
        <CompareButton id={c.id} testId={`compare-toggle-${c.id}`} />
        <StarButton id={c.id} testId={`star-toggle-${c.id}`} />
      </span>
    </div>
    <h3 className="mt-2 font-display font-bold text-lg leading-snug text-[#1C242B] group-hover:text-[#D96B43] transition-colors">{c.title}</h3>
    <p className="mt-1.5 text-sm text-slate-600 line-clamp-2">{c.summary}</p>
    <div className="mt-auto pt-4 flex items-center gap-2 text-xs">
      <span className="font-mono-ui text-[#3E6B5C]">{c.pay}</span>
      <span className="text-slate-300">·</span>
      <span className="text-slate-500 truncate">{c.labels[0]}</span>
      <ArrowUpRight size={15} className="ms-auto text-slate-300 group-hover:text-[#D96B43] transition-colors shrink-0" />
    </div>
  </Link>
);
